module.exports = __webpack_public_path__ + "static/media/samuel_nicolle_1.dc290ac7.jpg";